import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "upload-queue-panel__header" }
const _hoisted_2 = { class: "upload-queue-panel__title" }
const _hoisted_3 = { class: "upload-queue-panel__collapsible-inner" }
const _hoisted_4 = { class: "upload-queue-panel__list" }
const _hoisted_5 = { class: "upload-queue-item__body" }
const _hoisted_6 = { class: "upload-queue-item__row" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "upload-queue-item__meta" }
const _hoisted_9 = {
  key: 0,
  class: "upload-queue-item__progress"
}

import { computed, ref, watch } from 'vue'
import AppIcon from '@/components/ui-kit/icon/AppIcon.vue'
import AppTooltip from '@/components/ui-kit/tooltip/AppTooltip.vue'
import { getFileIcon } from '@/utils/fileIcons'
import { useUploadQueue, type UploadItem } from '@/composables/useUploadQueue'
import { i18n } from '@/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppUploadQueuePanel',
  setup(__props) {

const queue = useUploadQueue()

const collapsed = ref(false)

watch(
	() => queue.isActive.value,
	(active) => {
		if (!active) {
			collapsed.value = false
		}
	}
)

const headerText = computed(() => {
	if (queue.isActive.value) {
		return String(i18n.global.t('ui_uploading_files', {
			done: queue.doneCount.value,
			total: queue.totalCount.value,
		}))
	}
	if (queue.errorCount.value > 0) {
		return String(i18n.global.t('ui_upload_done_with_errors', { count: queue.errorCount.value }))
	}
	return String(i18n.global.t('ui_upload_complete'))
})

const iconColor = (item: UploadItem): string => {
	if (item.status === 'success') return '#438451'
	if (item.status === 'error') return '#e5484d'
	return '#979797'
}

const formatSize = (bytes: number): string => {
	if (bytes >= 1024 * 1024) {
		return String(i18n.global.t('ui_size_mb', { value: (bytes / (1024 * 1024)).toFixed(1) }))
	}
	if (bytes >= 1024) {
		return String(i18n.global.t('ui_size_kb', { value: Math.round(bytes / 1024) }))
	}
	return String(i18n.global.t('ui_size_bytes', { value: bytes }))
}

const metaText = (item: UploadItem): string => {
	switch (item.status) {
		case 'uploading':
			return `${item.progress}%`
		case 'success':
			return String(i18n.global.t('ui_done'))
		case 'error':
			return item.error || String(i18n.global.t('upload_error'))
		case 'canceled':
			return String(i18n.global.t('ui_canceled'))
		default:
			return formatSize(item.sizeBytes)
	}
}

return (_ctx: any,_cache: any) => {
  return (_unref(queue).visible.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "upload-queue-panel",
        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_unref(queue).pauseAutoClose())),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_unref(queue).resumeAutoClose()))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(headerText.value), 1),
          (_unref(queue).isActive.value)
            ? (_openBlock(), _createBlock(AppIcon, {
                key: 0,
                class: _normalizeClass({
					'upload-queue-panel__toggle': true,
					'upload-queue-panel__toggle--collapsed': collapsed.value
				}),
                name: "chevron-down",
                width: "18px",
                color: "#979797",
                cursor: "pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (collapsed.value = !collapsed.value))
              }, null, 8, ["class"]))
            : (_openBlock(), _createBlock(AppIcon, {
                key: 1,
                name: "close-bold",
                width: "18px",
                color: "#979797",
                cursor: "pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(queue).close()))
              }))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass({
				'upload-queue-panel__collapsible': true,
				'upload-queue-panel__collapsible--collapsed': collapsed.value
			})
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(queue).items.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(["upload-queue-item", `upload-queue-item--${item.status}`])
                }, [
                  _createVNode(AppIcon, {
                    class: "upload-queue-item__icon",
                    name: _unref(getFileIcon)(item.fileName),
                    width: "18px",
                    color: iconColor(item)
                  }, null, 8, ["name", "color"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", {
                        class: "upload-queue-item__name",
                        title: item.fileName
                      }, _toDisplayString(item.fileName), 9, _hoisted_7),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(metaText(item)), 1)
                    ]),
                    (item.status === 'pending' || item.status === 'uploading')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", {
                            class: "upload-queue-item__progress-bar",
                            style: _normalizeStyle({ width: item.progress + '%' })
                          }, null, 4)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (item.status === 'pending' || item.status === 'uploading')
                    ? (_openBlock(), _createBlock(AppTooltip, {
                        key: 0,
                        text: _ctx.$t('ui_cancel_upload')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            name: "close-bold",
                            width: "14px",
                            color: "#979797",
                            cursor: "pointer",
                            onClick: ($event: any) => (_unref(queue).cancel(item.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["text"]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ])
        ], 2)
      ], 32))
    : _createCommentVNode("", true)
}
}

})